<template>
  <div class="card-deck deck">
    <div class="card chart-card">
      <div class="card-body ch">
        <h6 class="card-title">Sales</h6>
        <bar-chart
          :chart-data="lineCollection"
          :options="options"
          :height="270"
        />
      </div>
    </div>
    <div class="card chart-card">
      <div class="card-body">
        <h6 class="card-title">{{ daughTitle }}</h6>
        <doughnut
          :chart-data="doughCollection"
          :options="options"
          :height="270"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./BarChart";
import Doughnut from "./Doughnut";
export default {
  name: "ChartCards",
  components: {
    BarChart,
    Doughnut,
  },
  extends: [BarChart, Doughnut],
  props: ["chartdata", "lineCollection", "doughCollection", "daughTitle"],

  data() {
    return {
      datacollection: null,
      doughDataCollection: null,
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
};
</script>
<style scoped>
.chart-card {
  height: 50%;
  border-radius: 10px;
  margin-top: 2%;
}
</style>
